<div class="pd-content-container">
    <div class="pd-definitions-content-container">
        <div class="pd-definitions-header">
            <h1>Definitions</h1>
            <!--<button hc-button buttonStyle="primary-alt" (click)="generateDownload()">Download Spreadsheet</button>-->
        </div>
        <hc-tab-set direction="horizontal">
            <hc-tab tabTitle="Types">
                <table hc-table [borders]="false" class="definitions-table" [dataSource]="typesDataSource" hcSort #typesSort>
                    <!-- Name Column -->
                    <ng-container hcColumnDef="name">
                        <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
                        <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <!-- Category Column -->
                    <ng-container hcColumnDef="category">
                        <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Category</th>
                        <td hc-cell *hcCellDef="let element">{{ element.category | titlecase }}</td>
                    </ng-container>

                    <!-- Description Column -->
                    <ng-container hcColumnDef="description">
                        <th hc-header-cell *hcHeaderCellDef id="descriptionHeader">Description</th>
                        <td hc-cell *hcCellDef="let element" [innerHtml]="element.description | sanitizeHtml"></td>
                    </ng-container>

                    <tr hc-header-row *hcHeaderRowDef="typesDisplayedColumns"></tr>
                    <tr hc-row *hcRowDef="let row; columns: typesDisplayedColumns"></tr>
                </table>
                <hc-pagination [length]="typesListLength" [pageSize]="typesPageSize"
                    [hidden]="loadError || loading" #typesPaginator></hc-pagination>
            </hc-tab>
            <hc-tab tabTitle="Statuses">
                <table hc-table [borders]="false" class="definitions-table" [dataSource]="statusesDataSource">
                    <!-- Name Column -->
                    <ng-container hcColumnDef="name">
                        <th hc-header-cell *hcHeaderCellDef id="nameHeader">Name</th>
                        <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <!-- Description Column -->
                    <ng-container hcColumnDef="description">
                        <th hc-header-cell *hcHeaderCellDef id="descriptionHeader">Description</th>
                        <td hc-cell *hcCellDef="let element" [innerHTML]="element.description"></td>
                    </ng-container>

                    <tr hc-header-row *hcHeaderRowDef="statusesDisplayedColumns"></tr>
                    <tr hc-row *hcRowDef="let row; columns: statusesDisplayedColumns"></tr>
                </table>
                <hc-pagination [length]="statusesListLength" [pageSize]="statusesPageSize"
                [hidden]="loadError || loading" #statusesPaginator></hc-pagination>
            </hc-tab>
        </hc-tab-set>
    </div>
</div>